// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  ga: 'G-P7DBTV1DEZ',
  production: false,
  firebase: {
    apiKey: "AIzaSyACyNknP2DqcyNs9pw3oiQZU9MjvY_Hslg",
    authDomain: "bc-hydro-apps.firebaseapp.com",
    projectId: "bc-hydro-apps",
    storageBucket: "bc-hydro-apps.appspot.com",
    messagingSenderId: "59682134907",
    appId: "1:59682134907:web:b794feb6bfc4747ebe7bde",
    measurementId: "G-F9LVZRZ9TK"
  }
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
